import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { localVerticalHead } from "@/config/seoLocal";
import { redirectLegacyMunicipality } from "@/lib/legacyRedirects";
import { assertServiceSlug } from "@/lib/slugGuards";

const ServiceSlugPage = lazy(() => import("@/pages/produkter/ServiceSlugPage"));

export const Route = createFileRoute("/kommersiella-batterier/$slug")({
  beforeLoad: ({ params }) => {
    redirectLegacyMunicipality("kommersiella-batterier", params.slug);
  },
  // Vertikalen har bara produktsidor – annars riktig 404.
  loader: ({ params }) => assertServiceSlug("kommersiella-batterier", params.slug, { municipalityPages: false }),
  head: ({ params }) => localVerticalHead("kommersiella-batterier", params.slug),
  component: () => <ServiceSlugPage vertical="kommersiella-batterier" fallback="none" />,
});
